import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

export const useGameSelection = (games, userPublicGames, isCreator) => {
  const [selectedGame, setSelectedGame] = useState(
    <FormattedMessage id='settings.games.chooseGame' />
  )
  const [selectedGameStorageFilter] = useState({})

  const onGameChange = game => {
    setSelectedGame(game)
  }

  const gamesAvailable = isCreator()
    ? games?.map(el => el.game.title)
    : userPublicGames?.map(el => el.game.title)

  return {
    selectedGame,
    setSelectedGame,
    selectedGameStorageFilter,
    onGameChange,
    gamesAvailable,
  }
}
